import { useEffect, useState } from "react";
import { StoneXModal } from "../../../../StoneXMui";
import AddBudgets from "./AddBudgets";
import { CommodityManagementApi } from "../../../../../Apis/Apis";
import { useLoadingState } from "../../../../../Hooks";
import { BudgetPricingStrategyModel, YearDataModel } from "../../../../../Generated/Commodity-Management-Api";
import { BudgetFilters } from "../Types";

interface AddBudgetsModalProps {
  open: boolean;
  years: YearDataModel[];
  onClose: () => void;
  onSave: (budgetFilter: BudgetFilters) => void;
}

export function AddBudgetsModal(props: AddBudgetsModalProps) {

  const { open, years, onClose, onSave } = props;

  const loadingState = useLoadingState();
  const [ pricingStrategies, setPricingStrategies ] = useState<BudgetPricingStrategyModel[]>([]);

  useEffect(() => {
    CommodityManagementApi.listPricingStrategies(loadingState.setLoadingState).then((q) => setPricingStrategies(q.data.rows ?? []));
  }, []);

  return <StoneXModal width='95%' header='Add Budgets' open={open} onClose={onClose} sx={{maxWidth: '95%', maxHeight: '90%'}} height={'90%'}>
    {pricingStrategies && 
      <AddBudgets years={years} pricingStrategies={pricingStrategies} onClose={onClose} onSave={onSave} onCancel={onClose}/>
    }
  </StoneXModal>
}